import { IFaq } from '../types/aboutTypes'

export const POINTS_FAQ_TEMP_ANSWER =
  'You earn points by taking action in the app: signing up, your first mobile login, scanning menus, saving restaurants, rating dishes, leaving reviews, sharing restaurants, inviting friends, subscribing to our newsletter, and engaging with us on Instagram. You also earn from daily login streaks and when people you invite accept a group invitation. See the "Ways to earn points" list on the Points page for the current point value of each action — new ways are added regularly!'

export const POINTS_FAQ_DATA: IFaq[] = [
  {
    id: 'points-faq-1',
    question: 'How can I earn more reward points?',
    answer: POINTS_FAQ_TEMP_ANSWER,
  },
  {
    id: 'points-faq-2',
    question: "What's the value of each reward point?",
    answer:
      'Think of points as your progress meter. Each month, your membership level gives you a points goal. Hit that goal and stay active, and you will unlock a credit grant at the next payout cycle (processed every two months). Those credits are what you can redeem for rewards—gift cards, discounts, and exclusive restaurant perks.',
  },
  {
    id: 'points-faq-3',
    question: 'How do I check my points balance?',
    answer:
      'You can view your points balance and available credits in the Points section. Your points balance shows how many points you have earned, and your credits show what you can redeem right now. Both update in real-time as you earn points and redeem credits.',
  },
  {
    id: 'points-faq-4',
    question: 'What rewards can I get with my credits?',
    answer:
      'Everyone can redeem credits for gift cards to places you already spend. Cashing out to your bank or Venmo and loading a Visa prepaid card to use anywhere are Explorer and VIP benefits — upgrade to unlock them. Dining credit you can spend directly at partner restaurants is coming soon. Check the rewards section to see what is currently available.',
  },
  {
    id: 'points-faq-5',
    question: 'Are there any expiration dates for my points?',
    answer:
      'Your points do not expire. As long as your account is active, your points remain yours to use towards your monthly goal. VIP members also enjoy a special rollover perk: a limited amount of unused points can carry forward to help boost your progress toward the next cycle\'s goals, giving you a momentum boost to reach your monthly goals again.',
  },
  {
    id: 'points-faq-6',
    question: 'Can I transfer my points to someone else?',
    answer:
      'Points are non-transferable and tied to your account to ensure security and prevent fraud. However, you can use your credits to purchase rewards like gift cards that you can share with others.',
  },
  {
    id: 'points-faq-7',
    question: 'What promotions can help me earn extra points?',
    answer:
      'We regularly run promotions and challenges that offer bonus points for specific activities like referring friends, trying new restaurants, or participating in seasonal campaigns. Stay tuned to our app notifications and social media for the latest opportunities to earn extra points!',
  },
  {
    id: 'points-faq-8',
    question: 'How do I find out about new ways to use my credits?',
    answer:
      'New rewards and ways to earn points are added regularly! Check the rewards section in the app to see what credits you can redeem, follow us on social media, subscribe to our newsletter, and enable app notifications to stay informed about the latest opportunities to earn points and redeem credits.',
  },
]

